import { useMemo } from 'react'
import {
  ConnectionProvider,
  WalletProvider,
} from '@solana/wallet-adapter-react'
import { getSolanaRpcUrl } from '../utils/sol/chains'

export default function SolanaProviders({ children }) {
  const endpoint = useMemo(() => getSolanaRpcUrl(), [])
  const wallets = useMemo(() => [], [])

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider wallets={wallets} autoConnect>
        {children}
      </WalletProvider>
    </ConnectionProvider>
  )
}
